var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50521 2.7819C9.81771 3.0944 10 3.51107 10 3.95378V12.0007C10 12.9382 9.24479 13.6673 8.33333 13.6673H1.66667C0.729167 13.6673 0 12.9382 0 12.0007V2.00065C0 1.08919 0.729167 0.333984 1.66667 0.333984H6.38021C6.82292 0.333984 7.23958 0.516276 7.55208 0.828776L9.50521 2.7819ZM8.75 12.0007H8.72396V4.50065H6.66667C6.19792 4.50065 5.83333 4.13607 5.83333 3.66732V1.61003H1.66667C1.43229 1.61003 1.25 1.79232 1.25 2.02669V12.0007C1.25 12.235 1.43229 12.4173 1.66667 12.4173H8.33333C8.54167 12.4173 8.75 12.235 8.75 12.0007ZM2.5 7.62565C2.5 7.28711 2.76042 7.00065 3.125 7.00065H6.875C7.21354 7.00065 7.5 7.28711 7.5 7.62565C7.5 7.99023 7.21354 8.25065 6.875 8.25065H3.125C2.76042 8.25065 2.5 7.99023 2.5 7.62565ZM6.875 9.50065C7.21354 9.50065 7.5 9.78711 7.5 10.1257C7.5 10.4902 7.21354 10.7507 6.875 10.7507H3.125C2.76042 10.7507 2.5 10.4902 2.5 10.1257C2.5 9.78711 2.76042 9.50065 3.125 9.50065H6.875Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon-file.e98f8ede3ddbba242cf740c4f1177d75.svg";
export { ForwardRef as ReactComponent };